export default function downloadTxtFile(data) {
  // Create a Blob containing the text data
  const blob = new Blob([JSON.stringify(data, null, 4)], {
    type: "text/plain",
  });
  // Create a link element
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  // Set the file name
  link.download = data.log_messages
    ? `${data.log_messages}-${data.start_timestamp}.txt`
    : "log_data.txt";
  // Append the link to the body
  document.body.appendChild(link);
  // Programmatically click the link to trigger the download
  link.click();
  // Clean up
  document.body.removeChild(link);
}
